import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { vatReturnSearchSchema } from '../../features/reports/search'
import { VatReturnPage } from '../../features/reports/vat-return-page'

export const Route = createFileRoute('/_app/vat-return')({
  staticData: { crumb: 'vatReturn' },
  validateSearch: vatReturnSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'reports.financial'),
  component: VatReturnPage,
})
